<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div>
        <v-chip
          class="mr-4 och-fix-chip-width-override"
          :color="`${color} lighten-1`"
          text-color="#000"
        >
          <span style="color: black">{{ resultList.length }}</span>
        </v-chip>
        {{ label }}
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-simple-table dense v-if="resultList.length > 0">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Row</th>
              <th class="text-left">Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="{ message, row } in resultList" :key="row">
              <td>{{ row }}</td>
              <td>{{ message }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    color: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    resultList: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style scoped>
.och-fix-chip-width-override {
  display: inline-block;
  min-width: 50px;
  text-align: center !important;
  font-weight: bold;
}
</style>
